import keyMirror from 'keymirror';

export default keyMirror({
  SET_CONFIG: null,
  LOAD_CONFIG: null,
  CLEAR_ERROR: null,
  UPDATE_I18N: null,
  CONFIG_WAS_LOADED: null,
  ERROR_LOADING_CONFIG: null,
  LOAD_ACCOUNT_INFO: null,
  ACCOUNT_INFO_WAS_LOADED: null,
  ERROR_LOADING_ACCOUNT_INFO: null,
  TOGGLE_PRODUCT_SORTING: null,
  START_PROVISION_ACCOUNT: null,
  ACCOUNT_PROVISIONED: null,
  ERROR_ACCOUNT_PROVISIONED: null
});
